import { render, staticRenderFns } from "./ModalConsumoCredito.vue?vue&type=template&id=4fbbe740&"
import script from "./ModalConsumoCredito.vue?vue&type=script&lang=js&"
export * from "./ModalConsumoCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports